// removed by extract-text-webpack-plugin
module.exports = {"button":"MlSeJN0mY18Us5hKpPnnK","primaryButton":"_315KNPRiYuOh5oHgTDMvLH","deleteButton":"_1OkmxPCwMo8Y0bMuxtXP26","deleteModal":"_2PJXyg6GYJAqDp04xE0hdj","deleteHeader":"hcmXOPZivg8XvEIIen-FQ"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/Buttons.scss
// module id = 399
// module chunks = 0